import jwtDecode from 'jwt-decode';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import {
  EventTypes,
  ScreenLoadEventNames,
  emitEvent,
} from '@pmi/analytics-layer';
import { userSelector } from '../store/shared/userSlice';
import { accountSelector } from '../store/shared/accountSlice';
import { JwtDecodedUser } from '../models/UserModels';
import { useGetAccountDataQuery } from '../navigation/apiSlice';

export default function useReportScreenLoad(skip = false) {
  const { value: user } = useSelector(userSelector);
  const accessToken = user ? user.access_token : '';
  const { currentAccountId } = useSelector(accountSelector);
  const { accountId } = useParams<{ accountId: string }>();
  const acctId = currentAccountId || accountId;
  const location = useLocation();
  const authUser: JwtDecodedUser = accessToken ? jwtDecode(accessToken) : null;
  const [currentPath, setCurrentPath] = useState('');

  const {
    data: accountData,
    isLoading,
    isFetching,
  } = useGetAccountDataQuery(acctId, {
    skip: !acctId || skip,
  });

  const emitReport = (lineOfBusiness: string) => {
    emitEvent({
      eventType: EventTypes.ScreenLoad,
      eventName: ScreenLoadEventNames.PureScreenLoad,
      eventData: {},
      loggedInUser: {
        autoRenewal: '',
        certificationSegment: '',
        certificationStatus: '',
        membershipSegment: '',
        membershipStatus: '',
        membershipTier: '',
        pduStatus: '',
        pmID: '',
        pmiID: authUser.id,
        profileCompletion: '',
        region: '',
        userSegment: '',
        accountid: acctId,
        accountName: accountData?.name,
        dealid: accountData?.deals
          ? accountData.deals.map((dealId) => dealId).join(',')
          : '',
        lineofbusiness: lineOfBusiness,
      },
    });
  };

  useEffect(() => {
    if (!accessToken) return;
    if (
      location.pathname === '/signin-callback/redirect' ||
      location.pathname === '/signin-callback' ||
      location.pathname === '/admin' ||
      location.pathname.startsWith('/admin/account-2fa/') ||
      location.pathname.endsWith('/reports') ||
      location.pathname.endsWith('/reports/') ||
      location.pathname.endsWith('/groups') ||
      location.pathname.endsWith('/groups/') ||
      location.pathname.startsWith('/admin/select-account')
    ) {
      return;
    }

    if (currentPath === location.pathname) {
      return;
    }

    if (
      !isFetching &&
      !isLoading &&
      accountData &&
      accountData.engagements &&
      accountData.engagements.length > 0
    ) {
      emitReport(accountData.engagements[0].toLowerCase());
      setCurrentPath(location.pathname);
    }
  }, [accessToken, accountData, location]);
}
